import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  SimpleGrid,
  Box,
  Image,
  useColorModeValue,
} from '@chakra-ui/react';
import { useMedia } from '../hooks/useMedia';

export default function CommentImageSelectModal({ isOpen, onClose, siteId, onSelect }) {
  const { media, loading, loadMedia } = useMedia(siteId);

  React.useEffect(() => {
    if (isOpen && siteId) {
      loadMedia();
    }
  }, [isOpen, siteId, loadMedia]);

  const borderColor = useColorModeValue('gray.200', 'gray.600');

  const handleSelect = (mediaItem) => {
    if (mediaItem?.url) {
      onSelect(mediaItem.url);
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent maxH="90vh">
        <ModalHeader>Select an Image</ModalHeader>
        <ModalCloseButton />
        <ModalBody overflowY="auto" pb={6}>
          {loading ? (
            <Box>Loading site media...</Box>
          ) : !media || media.length === 0 ? (
            <Box>No media available</Box>
          ) : (
            <SimpleGrid columns={[2, 3, 4]} spacing={4}>
              {media.map((item) => (
                <Box
                  key={item.id || item.url}
                  cursor="pointer"
                  onClick={() => handleSelect(item)}
                  borderWidth="1px"
                  borderColor={borderColor}
                  borderRadius="md"
                  overflow="hidden"
                  transition="all 0.2s"
                  _hover={{ transform: 'scale(1.02)', shadow: 'md' }}
                >
                  <Image
                    src={item.url}
                    alt={item.fileName || 'Site media'}
                    objectFit="cover"
                    w="100%"
                    h="150px"
                  />
                </Box>
              ))}
            </SimpleGrid>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
